import React, { FC, useEffect, useState } from 'react'

import { useRouter } from 'next/navigation'

import { Modal, Txt, StandardButton, Icon } from 'src/components/atoms'

import { useGetProjects, useProject, useToast } from 'src/hooks'
import { Routes } from 'src/routes'

type Props = {
  projectIds: string[]
  isOpen: boolean
  onClose: () => void
}

export const DeleteProjectModal: FC<Props> = ({ projectIds, isOpen, onClose }) => {
  const [isDeleting, setIsDeleting] = useState(false)

  const { deleteProject } = useProject()
  const { refetch } = useGetProjects()
  const { displayStandardTextToast, displayErrorTextToast } = useToast()

  const router = useRouter()

  const handleOnDelete = async (event: React.MouseEvent) => {
    event.stopPropagation()

    setIsDeleting(true)

    try {
      await Promise.all(projectIds.map(id => deleteProject({ byId: id })))
      refetch()
      displayStandardTextToast('プロジェクト削除処理を開始しました')

      router.replace(Routes.ProjectTop.path)
    } catch {
      displayErrorTextToast('プロジェクト削除処理の開始に失敗しました')
      setIsDeleting(false)
    }
  }

  useEffect(() => {
    return () => setIsDeleting(false)
  }, [])

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="md"
      headerInner={
        <div className="tw-px-s1">
          <div className="tw-flex tw-items-center">
            <Icon size="--r1" path="trash/soft/line" className="tw-accent-standardText-secondary" />
            <Txt sizeType="l" className="tw-ml-r-3 tw-font-bold">
              プロジェクト削除
            </Txt>
          </div>
        </div>
      }
    >
      <div className="tw-w-[37.86rem] tw-p-s2">
        <Txt lineHeight="l">
          プロジェクト削除を実行すると情報の復元はできません。ROOV
          compassで設定や、お客様情報も完全に削除されます。本当によろしいですか？
        </Txt>

        <div className="tw-centering tw-mt-s3">
          <StandardButton
            buttonType="secondary"
            text="キャンセル"
            prependIconPath="close/soft/line"
            size="l"
            onClick={onClose}
          />
          <StandardButton
            buttonType="danger"
            text="削除"
            prependIconPath="trash/soft/line"
            isLoading={isDeleting}
            size="l"
            onClick={handleOnDelete}
            className="tw-ml-s2"
          />
        </div>
      </div>
    </Modal>
  )
}
